export default {
    routerName: '登陆日志',
    log: {
        searchName: '检索条件',
        accountName: '账户名',
        status: '状态',
        open: '成功',
        close: '失败',
        createTime: '创建时间',
        createStartTime: '创建开始时间',
        createEndTime: '创建结束时间',
    },
    table: {
        id: 'ID',
        logName: '日志名',
        accountName: '账户名',
        ip: 'IP',
        msg: '日志信息',
        createTime: '创建时间',
        status: '状态',
    },
};
